'use client';

import { useEffect, useState } from 'react';

interface ContactHeroProps {
  language: 'en' | 'es';
}

const ContactHero = ({ language }: ContactHeroProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const content = {
    en: {
      headline: 'Get In Touch',
      subhead: 'We respond within 24 business hours.',
    },
    es: {
      headline: 'Contáctanos',
      subhead: 'Respondemos en menos de 24 horas hábiles.',
    },
  };

  return (
    <section className="pt-32 pb-12 px-6">
      <div className="max-w-screen-xl mx-auto text-center">
        <div className={`space-y-4 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
          <h1 className="text-5xl md:text-6xl font-bold tracking-tight text-foreground">
            {content[language].headline}
          </h1>
          <p className="text-xl text-muted-foreground">
            {content[language].subhead}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;